import { i as p, g as c, N as n } from "./network-CMCgOUpf.js";
function i(e) {
  const s = p(e) ? "https://testnets.opensea.io" : "https://opensea.io";
  let t = c(e);
  return t === "mainnet" && (t = "ethereum"), `${s}/assets/${t}`;
}
function u(e, s) {
  return `${i(e)}/${s}`;
}
function l(e, s, t) {
  return `${i(e)}/${s}/${t}`;
}
function r(e) {
  switch (e) {
    case n.Optimism:
      return "https://optimistic.etherscan.io";
    case n.Goerli:
      return "https://goerli.etherscan.io";
    case n.Sepolia:
      return "https://sepolia.etherscan.io";
    case n.Base:
      return "https://basescan.org";
    case n.Mainnet:
      return "https://etherscan.io";
    case n.Matic:
      return "https://polygonscan.com";
    default:
      throw new Error("Unsupported Network passed to getEtherscanBaseURL");
  }
}
function f(e, s, t) {
  return `${r(e)}/nft/${s}/${t}`;
}
function h(e, s) {
  return `${r(e)}/tx/${s}`;
}
function o(e, s) {
  return `${r(e)}/address/${s}`;
}
function d(e, s) {
  return o(e, s);
}
function g(e, s) {
  return o(e, s);
}
function m(e) {
  return e === 1 ? "https://gallery.manifold.xyz" : `https://gallery.manifold.xyz/${c(e)}`;
}
function U(e) {
  return e.includes("https://www.youtube.com") || e.includes("https://youtu.be") || e.includes("https://youtube.com") || e.includes("https://www.youtube-nocookie.com");
}
const L = (e, s) => {
  let t = e;
  if (t.includes("ipfs://ipfs/"))
    t = t.replace("ipfs://ipfs/", "https://ipfs.io/ipfs/");
  else if (t.includes("ipfs://"))
    t = t.replace("ipfs://", "https://ipfs.io/ipfs/");
  else if (t.includes("ipfs:\\/\\/"))
    t = t.replace("ipfs:\\/\\/", "https://ipfs.io/ipfs/");
  else if (t.includes("ar://"))
    t = t.replace("ar://", "https://arweave.net/");
  else if (t.includes("ar:\\/\\/"))
    t = t.replace("ar:\\/\\/", "https://arweave.net/");
  else if (s && t.includes("api.opensea.io/api/v1/metadata/") && t.includes("{id}")) {
    let a = s.toHexString();
    a = a.replace("0x", ""), t = t.replace("{id}", a);
  }
  return t;
}, $ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  convertPotentialWeb3ProtocolURLToWeb2URL: L,
  getEtherscanBaseURL: r,
  getEtherscanURLForAddress: o,
  getEtherscanURLForContract: d,
  getEtherscanURLForToken: f,
  getEtherscanURLForTransactionHash: h,
  getEtherscanURLForWallet: g,
  getManifoldGalleryBaseURL: m,
  getOpenSeaBaseURL: i,
  getOpenSeaCollectionURL: u,
  getOpenSeaTokenURL: l,
  isYoutubeVideoURL: U
}, Symbol.toStringTag, { value: "Module" }));
export {
  i as a,
  u as b,
  l as c,
  r as d,
  f as e,
  h as f,
  o as g,
  d as h,
  g as i,
  m as j,
  U as k,
  L as l,
  $ as u
};
